import React, { useEffect } from 'react'

import TitleLayout from './TitleLayout';
import TrustedPartner from './TrustedPartner';
import ShowLayout from './ShowLayout';
import KontejneryLayout from './KontejneryLayout';
import DovozLayout from './DovozLayout';
import OdvozLayout from './OdvozLayout';
import BgLayout from '../components/Base/BgLayout';
import VideoLayout from './VideoLayout';
import ZemniPrace from './ZemniPrace';
import ContactForm from './ContactForm';
import { sendBrevoTest, sendContact } from '../firebase/config';

export default function DopravaBrno() {

  return (
    <div
      style={{
        overflowX: "hidden",
        overflowY: 'hidden',
        maxWidth: "100%",
        position: "relative",
        minWidth: "300px",
      }}
    >
      <TitleLayout/>
      <TrustedPartner/>
      <KontejneryLayout/>
      <DovozLayout/>
      <OdvozLayout/>
      <VideoLayout/>
      <ZemniPrace/>
      <ContactForm/>
    </div>
  )
}
